export default class ClubBankAccountFinleap {

    static fromData(data) {
        if (!data) {
            return;
        }

        let clubBankAccountFinleap = new ClubBankAccountFinleap();
        clubBankAccountFinleap.id = data.id;
        clubBankAccountFinleap.iban = data.iban;
        clubBankAccountFinleap.bic = data.bic;
        clubBankAccountFinleap.owner = data.owner;

        Object.seal(clubBankAccountFinleap);
        return clubBankAccountFinleap;
    }

    displayText() {

        return 'IBAN: ' + this.iban
            + ('' !== this.bic ? ' / BIC: ' + this.bic : '')
            + ' / Kontoinhaber: ' + this.owner;
    }

}
